import React from 'react';

const AppBase: React.FC = ({ children }) => {
  return <div>{children}</div>;
};

export default AppBase;
